(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQuuke = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.conservatoireapplication === "undefined") {
        jQuery.extend(sm.portal.vm, { conservatoireapplication: {} });
    }

    function InitializeSections (application, coreSections) {
        var conservatoiresSections = [] ;
        var conservatoireSpecialismsModel = new sm.portal.vm.ConservatoireSpecialismsViewModel();
        //Conservatoire
        conservatoiresSections.push(new sm.portal.vm.ApplicationSectionModel({
            AppearanceOrder: 45,
            SectionName: 'ConservatoireSpecialisms',
            SectionTitle: sm.portal.utility.getResourceValue('ConservatoireSpecialisms'),
            SectionNavTitle: sm.portal.utility.getResourceValue('ConservatoireSpecialisms'),
            Applied: true,
            Required: false,
            SectionModel: conservatoireSpecialismsModel,
            SectionTemplate: "ConservatoireSpecialismsTemplate"
        }));

        application.LastSectionName('ApplicationInformation');

        return coreSections.concat(conservatoiresSections);
    }

    function MoveToNextSection(application, nextSectionObj){
        if (nextSectionObj !== null) {
            if (application.CurrentSectionName() === "Academic") {
                var isValid = application.GetSectionModel('Academic').ValidateModel();
                if (isValid) {
                    nextSectionObj.Active(true);
                }
            }
        }
    }

    function ExtractATO(application, submitModel, stdAttempt, stdPerson){
        var conservatoireSpecialismsSecData = application.GetSectionModel('ConservatoireSpecialisms');

        // Construct the Conservatoire Specialisms object        
        var conservatoireSpecialismsData = conservatoireSpecialismsSecData.ExtractATO();

        var conservatoireSpecialismsInformation = Array();

        for (var i = 0; i < conservatoireSpecialismsData.length; i++) {
            var specialismID = "0";
            var specialismCategoryID = "0";
            var staffID = "0";
            var reasonForStaffChange = "";

            if (!sm.portal.utility.isNullOrEmpty(conservatoireSpecialismsData[i].SpecialismID) && conservatoireSpecialismsData[i].SpecialismID > 0) {
                specialismID = conservatoireSpecialismsData[i].SpecialismID;
            }

            if (!sm.portal.utility.isNullOrEmpty(conservatoireSpecialismsData[i].SpecialismCategoryID) && conservatoireSpecialismsData[i].SpecialismCategoryID > 0) {
                specialismCategoryID = conservatoireSpecialismsData[i].SpecialismCategoryID;
            }

            if (!sm.portal.utility.isNullOrEmpty(conservatoireSpecialismsData[i].StaffID) && conservatoireSpecialismsData[i].StaffID > 0) {
                staffID = conservatoireSpecialismsData[i].StaffID;
            }

            if (!sm.portal.utility.isNullOrEmpty(conservatoireSpecialismsData[i].ReasonForStaffChange)) {
                reasonForStaffChange = conservatoireSpecialismsData[i].ReasonForStaffChange;
            }

            var conservatoireSpecialismFields = '{"SpecialismID": "';
            conservatoireSpecialismFields += specialismID;
            conservatoireSpecialismFields += '", "SpecialismCategoryID": "';
            conservatoireSpecialismFields += specialismCategoryID;
            conservatoireSpecialismFields += '", "StaffID": "';
            conservatoireSpecialismFields += staffID;
            conservatoireSpecialismFields += '", "ReasonForStaffChange": "';
            conservatoireSpecialismFields += reasonForStaffChange;
            conservatoireSpecialismFields += '"}';

            conservatoireSpecialismsInformation.push(conservatoireSpecialismFields);
        }

        submitModel.conservatoireSpecialismsInformation = conservatoireSpecialismsInformation;

        return submitModel;
    }


    jQuery.extend(true, sm.portal.vm.conservatoireapplication, {
        InitializeSections: InitializeSections,
        MoveToNextSection: MoveToNextSection,
        ExtractATO: ExtractATO
    });

})(jQuery);